import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-serif/500.css";
import "@fontsource/ibm-plex-serif/600.css";
import "@fontsource/ibm-plex-mono/400.css";

import "./styles/app.css";

import { App } from "./App";

const mount = document.getElementById("dashboard");
if (!mount) throw new Error("no #dashboard to mount on");

createRoot(mount).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
